import { useCallback, useContext } from 'react';
import { Link } from 'react-router-dom';
import { ConfigContext } from 'src/configContext';
import { Button } from 'src/common/Button/Button';
import { I18n } from 'src/modules/common/components/I18n/I18n';
import { MESSAGES } from 'src/modules/common/constants';
import { ArrowRightIcon } from 'src/modules/common/icons/ArrowRightIcon';
import { PATHS } from 'src/types/Paths';

type Props = {
    searchParams: URLSearchParams;
    fullWidth?: boolean;
}

export const ValvesSelectActuatorButton = ({ searchParams, fullWidth }: Props) => {
    const { gaPush } = useContext(ConfigContext);

    const onClick = useCallback(() => {
        gaPush({
            event: 'gaEvent',
            eventCategory: 'sizing tool',
            eventAction: 'step 4 - actuator parameters',
            eventLabel: 'choose matching actuator',
        });
    }, [gaPush]);

    return (
        <Button
            onClick={onClick}
            className="vss-valves-select-actuator-button"
            fullWidth={fullWidth}
            as={Link}
            size="md"
            to={{
                pathname: PATHS.Accessories,
                search: searchParams.toString(),
            }}
            icon={(
                <div className="vss-valves-select-actuator-button__icon">
                    <ArrowRightIcon/>
                </div>
            )}
        >
            <I18n messageId={MESSAGES.selectDevice}/>
        </Button>
    );
};
